import React, { PropsWithChildren } from 'react';

import styles from './TaskBarTabs.module.css';

export function TaskBarTabPanel({
  children,
  value,
  index,
  extraClass,
}: {
  value: string;
  index: string;
  extraClass?: string;
} & PropsWithChildren) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={`${styles.task_bar_tab} ${extraClass || ''}`}
    >
      {value === index && children}
    </div>
  );
}
